// STYLES
import * as Style from "./ReportStatisticsStyle";

// LIBRARIES
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// MISC
import { Tabs } from "models/GeneralTypes/generalTypes";

// ASSETS
import PeopleIcon from "assets/Icons/PeopleIcon.svg";
import MoneyIcon from "assets/Icons/MoneyIcon.svg";
import BoardIcon from "assets/Icons/BoardIcon.svg";

// REDUX
import { useAppDispatch } from "hooks/reduxHooks";
import { toggleActiveTab } from "slices/uiSlice";

// COMPONENTS
import ReportStatisticElement from "../ReportStatisticElement/ReportStatisticElement";

const ReportStatistics = ({ reportStatisticsData }) => {
  // PROPS

  // CONSTANTS USING LIBRARIES
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  // CONSTANTS USING HOOKS

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleUsersReports = () => {
    dispatch(toggleActiveTab(Tabs.USERS));
    navigate("/reports");
  };

  const handlePaymentsReports = () => {
    dispatch(toggleActiveTab(Tabs.PAYMENTS));
    navigate("/invoices");
  };

  return (
    <Style.ReportStatisticContainer>
       <Style.ContainerTitle>
        {t("page.dashboard.reportStatistics.title")}
      </Style.ContainerTitle>
      <Style.ReportStatisticWrapper>
     
        <Style.ReportStatisticContent>
          <Style.ReportStatisticElement>
            <ReportStatisticElement
              onClick={handleUsersReports}
              image={PeopleIcon}
              title={t("page.dashboard.reportStatistics.registeredUsers")}
              value={reportStatisticsData.noOfRegisteredUsers || 0}
            />
          </Style.ReportStatisticElement>

          <Style.ReportStatisticElement>
            <ReportStatisticElement
              onClick={() => {}}
              image={PeopleIcon}
              title={t("page.dashboard.reportStatistics.agecategory")}
              value={`${reportStatisticsData.minAge}-${reportStatisticsData.maxAge} (${parseInt(reportStatisticsData.percentageOfFemales)}% females)`}
            />
          </Style.ReportStatisticElement>

          <Style.ReportStatisticElement>
            <ReportStatisticElement
              onClick={handlePaymentsReports}
              image={MoneyIcon}
              title={t("page.dashboard.reportStatistics.totalAmountCollected")}
              value={reportStatisticsData.totalIncome || 0}
            />
          </Style.ReportStatisticElement>

          <Style.ReportStatisticElement>
            <ReportStatisticElement
              onClick={() => {}}
              image={BoardIcon}
              title={t("page.dashboard.reportStatistics.availableBoards")}
              value={`${reportStatisticsData.noOfAvailableSupBoards || 0} / ${
                reportStatisticsData.noOfTotalSupBoards || 0
              } `}
            />
          </Style.ReportStatisticElement>
        </Style.ReportStatisticContent>
      </Style.ReportStatisticWrapper>
    </Style.ReportStatisticContainer>
  );
};

export default ReportStatistics;
